"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrateTaskViewTableQueryState = exports.taskViewFieldHydrators = void 0;
const view_query_params_1 = require("../../../../common/view-query-params");
const task_view_1 = require("../../../../store/catalogs/task-view");
const taskViewHydrationOrder = [
    view_query_params_1.ViewQueryStateField.DynamicColumns,
    view_query_params_1.ViewQueryStateField.Filter,
    view_query_params_1.ViewQueryStateField.Search,
    view_query_params_1.ViewQueryStateField.Sort,
    view_query_params_1.ViewQueryStateField.PageSize,
];
exports.taskViewFieldHydrators = {
    [view_query_params_1.ViewQueryStateField.Filter]: ({ catalogId, dispatch, state }) => {
        dispatch((0, task_view_1.setTaskViewTableFilter)(catalogId, state[view_query_params_1.ViewQueryStateField.Filter]));
    },
    [view_query_params_1.ViewQueryStateField.Search]: ({ catalogId, dispatch, state }) => {
        dispatch((0, task_view_1.setTaskViewTableSearch)(catalogId, state[view_query_params_1.ViewQueryStateField.Search]));
    },
    [view_query_params_1.ViewQueryStateField.Sort]: ({ catalogId, dispatch, state }) => {
        dispatch((0, task_view_1.setTaskViewTableSort)(catalogId, state[view_query_params_1.ViewQueryStateField.Sort]));
    },
    [view_query_params_1.ViewQueryStateField.PageSize]: ({ catalogId, dispatch, state }) => {
        dispatch((0, task_view_1.setTaskViewTablePageSize)(catalogId, state[view_query_params_1.ViewQueryStateField.PageSize]));
    },
    [view_query_params_1.ViewQueryStateField.DynamicColumns]: ({ onHydrateDynamicColumns, state }) => {
        onHydrateDynamicColumns === null || onHydrateDynamicColumns === void 0 ? void 0 : onHydrateDynamicColumns(state[view_query_params_1.ViewQueryStateField.DynamicColumns]);
    },
};
const hydrateTaskViewTableQueryState = (context) => {
    taskViewHydrationOrder.forEach((field) => {
        if (field in context.state) {
            exports.taskViewFieldHydrators[field](context);
        }
    });
};
exports.hydrateTaskViewTableQueryState = hydrateTaskViewTableQueryState;
